import { Injectable } from '@angular/core';
import { ApplicationInsights, eSeverityLevel, IPageViewTelemetry } from '@microsoft/applicationinsights-web';
import { SettingsService, T4Environment } from './settings.service';

@Injectable({
  providedIn: 'root',
})
export class InsightsService {

  private appInsights: ApplicationInsights;
  private properties: any = {};

  // Add/Update a give property
  public setProperty(key: string, value: string) {
    this.properties[key] = value;
  }

   constructor(private settings: SettingsService) {
      this.init();
  }
    
  private init() {
    if (!this.settings.appInsightsKey) return;

    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: this.settings.appInsightsKey,
        maxAjaxCallsPerView: -1,
        enableAutoRouteTracking: false,
        disableAjaxTracking: true        
      }
    });

    this.appInsights.loadAppInsights();
  }

  private currentPage: { name: string, url: string };
  public logPageView(name?: string, url?: string) {
    if (!this.appInsights) this.init();
    if (!this.appInsights) return;

    if (this.currentPage) {
      this.appInsights.stopTrackPage(this.currentPage.name, this.currentPage.url);
      this.currentPage = null;
    }

    var x: IPageViewTelemetry;
    this.appInsights.startTrackPage(name);

    this.currentPage = { name: name, url: url };
  }

  public logEvent(name: string, properties?: { [key: string]: string }, measurements?: { [key: string]: number }) {
    if (!this.appInsights) this.init();
    if (!this.appInsights) return;

    this.appInsights.trackEvent({
      name: name,
      properties: this.AddGlobalProperties(properties),
      measurements: measurements 
    });
    } 

  public logError(error: Error, properties?: { [key: string]: string }, measurements?: { [key: string]: number }) {
    if (!this.appInsights) this.init();
    if (!this.appInsights) return;

      this.appInsights.trackException({
        error: error,
        properties: this.AddGlobalProperties(properties),
        measurements: measurements
      });
    }

  public logDependency(method: string, url: string, path: string, time: number, success: boolean, resultCode: number) {
    if (!this.appInsights) this.init();
    if (!this.appInsights) return;

    var props = {};
    var name = url;

    // Sched query string
    if (name.indexOf("?") > 0) {
      name = name.substring(0, name.indexOf("?"));
      props["QueryString"] = url.substring(url.indexOf("?"));
    }

    props["name"] = name;
    props["url"] = url;
    props["path"] = path;

    this.appInsights.trackDependencyData(
      {
        id: this.newId(),
        type: "API",
        name: method + " " + name,
        data: path,
        duration: time,
        success: success,
        responseCode: resultCode,
        properties: this.AddGlobalProperties(props)
      });
  }


  public trackTrace(message: string, props?: { [key: string]: string }) {
    this.trackDetailedTrace(message, eSeverityLevel.Information, "", props);
  }

  public trackDetailedTrace(message: string, severity: eSeverityLevel, key?: string, props?: { [key: string]: string }) {
    if (!this.appInsights) this.init();
    if (!this.appInsights) return;

    this.appInsights.trackTrace(
      {
        message: message,
        severityLevel: severity,
        iKey: key,
      },
        this.AddGlobalProperties(props)
      );
  }

  private AddGlobalProperties(properties?: { [key: string]: string }): { [key: string]: string } {
    if (!properties) {
      properties = {};
    }

    //add your custom properties such as app version
    properties.appName = this.settings.appName;
    properties.appVersion = this.settings.appVersion;
    properties.Environment = T4Environment[this.settings.Environment];

    // Add other properties
    for (var key in this.properties)
      properties[key] = this.properties[key];

    return properties;
  }

    private newId():string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    public setAuthenticatedUserId(userId: string, impersonating: string = null): void {
      if (!this.appInsights) this.init();
      if (!this.appInsights) return;

      var val = userId;
        if (impersonating) val += " (" + impersonating + ")";
        this.appInsights.setAuthenticatedUserContext(val);
    }
} 
